module.exports = {
	"articleTitle1": "SportsMonday Column: How my dream came true ",
	"catImage": "orangestar.png",
	"totalCats": 3,
	"name": "Elbel Field",
	"articleLink1": "https://www.michigandaily.com/section/football/sportsmonday-column-how-my-dream-came-true",
	"articleLink2": "https://www.michigandaily.com/news/u-celebrates-elbel-field-recreational-facilities-renovations",
	"articleSnippet1": "Apr 16, 2017 ... ... creeping over the scoreboard at Michigan Stadium, the band warming up in the \ndark at Elbel Field, the Michigan legends walking the streets.",
	"articleSnippet2": "Sep 8, 2011 ... Chris Ryba/Daily: Sports teams play on Elbel Field last night. The field was \nrecently renovated as part of a $1.6 million Department of ...",
	"totalMisc": 0,
	"articleTitle2": "Elbel Field receives upgrade with new artificial turf",
	"address": "336 Hill St, Ann Arbor, MI 48104",
	"images": [
		{
			"source": "https://www.michigandaily.com/sites/default/files/styles/large/public/160919/agc.NEW_.CSGTailgate.9.17.16.0026.jpg?itok=Sx2ii7VJ",
			"author": "Amelia Cacchione",
			"caption": "LSA sophomore Ingrid Lindquist hands out pizza to students at the CSG tailgate on Saturday at Elbel Field."
		}
	],
	"position": {
		"lat": 42.269937,
		"lng": -83.745207
	},
	"tips": [
		{
			"text": "This is one of only like three places on campus to play volleyball.",
			"person": "Erik Forkin"
		},
		{
			"text": "Nice place to play football and soccer since there's an actual turf field here.",
			"person": "Erik Forkin"
		}
	],
	"bathroomrating": [
		{
			"rating": 1,
			"bathroom": "Elbel Bathroom"
		}
	],
	"categories": {
		"yogaspot": 1,
		"pickupsports": 1,
		"location": 1,
		"recarea": 1,
		"sunbathingspot": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/elbelfield.json
// module id = 872
// module chunks = 0